import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../../context/AuthContext';
import AppNav from '../app/AppNav';

// ── Fading headline ───────────────────────────────────────────────────────────
const PHRASES = [
  'What interests you today?',
  'Connecting comunities',
  'Enriching Lives',
  'You are never alone',
  'Home away from home',
  'Connect with your community',
  'Simplifying life abroad',
];

const FadingHeadline: React.FC = () => {
  const [index, setIndex] = React.useState(0);
  const [visible, setVisible] = React.useState(true);

  useEffect(() => {
    const timer = setInterval(() => {
      setVisible(false);
      setTimeout(() => { setIndex(i => (i + 1) % PHRASES.length); setVisible(true); }, 2000);
    }, 7000);
    return () => clearInterval(timer);
  }, []);

  return (
    <h1
      className="mb-4"
      style={{ transition: 'opacity 2s ease', opacity: visible ? 1 : 0, minHeight: '4rem', lineHeight: 1.2, fontSize: 'clamp(2rem, 5vw, 3rem)', fontWeight: 800, color: 'white', letterSpacing: '-0.02em' }}
    >
      {PHRASES[index]}
    </h1>
  );
};

// ── Hero ──────────────────────────────────────────────────────────────────────
const HeroSection: React.FC = () => {
  const navigate = useNavigate();
  const { authUser, loading } = useAuth();

  useEffect(() => {
    if (!loading && authUser) navigate('/groups', { replace: true });
  }, [authUser, loading, navigate]);

  return (
    <>
      <AppNav />
      <div
        id="home"
        className="relative text-white text-center px-6 pt-16 pb-8 sm:pt-24 sm:pb-10"
        style={{ overflow: 'hidden' }}
      >
        {/* Background video */}
        <video
          autoPlay
          muted
          loop
          playsInline
          style={{ position: 'absolute', inset: 0, width: '100%', height: '100%', objectFit: 'cover', zIndex: 0 }}
          src="/hero-bg.mp4"
        />
        {/* Dark overlay to keep text readable */}
        <div style={{ position: 'absolute', inset: 0, background: 'rgba(30, 27, 75, 0.62)', zIndex: 1 }} />

        <div className="relative max-w-2xl mx-auto" style={{ zIndex: 2 }}>
          <span className="inline-block text-xs font-semibold tracking-widest uppercase text-indigo-300 mb-5">
            Your community app
          </span>

          <FadingHeadline />

          <br />
          <p className="text-base sm:text-lg max-w-lg mx-auto leading-relaxed" style={{ color: 'rgba(255,255,255,0.75)' }}>
            One stop solution to all your community needs — live connected, discover what matters, and belong wherever you are.
          </p>
          <br />

          <br />
          <p className="text-indigo-400 text-xs tracking-wide" style={{ marginBottom: '3rem' }}>
            Free &nbsp;·&nbsp; Safe &amp; Trusted &nbsp;·&nbsp; For Everyone
          </p>

          {/* Scroll indicator */}
          <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', gap: '0.5rem' }}>
            <span style={{ fontSize: '0.7rem', letterSpacing: '0.12em', textTransform: 'uppercase', color: 'rgba(255,255,255,0.8)' }}>Explore</span>
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="rgba(255,255,255,0.85)" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" style={{ animation: 'bounce 1.6s ease-in-out infinite' }}>
              <polyline points="6 9 12 15 18 9" />
            </svg>
          </div>
          <style>{`@keyframes bounce { 0%,100%{transform:translateY(0);opacity:0.7} 50%{transform:translateY(6px);opacity:1} }`}</style>
        </div>
      </div>
    </>
  );
};

export default HeroSection;
